var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('t-document',{attrs:{"standalone":""}},[_c('navigation',{attrs:{"items":_vm.items}}),_vm._v(" "),_c('nuxt'),_vm._v(" "),_c('portal-target',{attrs:{"name":"modals","multiple":""}}),_vm._v(" "),_c('notifications')],1)}
var staticRenderFns = []

export { render, staticRenderFns }